// 用户相关
export const USER_SIGN_IN = 'USER_SIGN_IN'
export const USER_SIGN_OUT = 'USER_SIGN_OUT'

// 语言相关
export const LANG_CHANGE = 'LANG_CHANGE'
export const LANG_ADD_NEW = 'LANG_ADD_NEW'
